import { render, staticRenderFns } from "./TemplateInspection.vue?vue&type=template&id=ecb682e6&"
import script from "./TemplateInspection.vue?vue&type=script&lang=js&"
export * from "./TemplateInspection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports